










import { Vue, Prop, Component } from 'vue-property-decorator';

import { FixtureInterface } from '@/interfaces/interfaces';
import { getFixtureDate } from '@/services/FixtureService';

@Component
export default class FixtureDetailsMobile extends Vue {
  @Prop() private fixture!: FixtureInterface;

  get fixtureDate() {
    return getFixtureDate(this.fixture);
  }
}
